import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const MissionVision = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-catalina-blue text-center mb-12">
          Our Mission & Vision
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="w-32 h-32 mx-auto mb-6 overflow-hidden rounded-lg">
              <img 
                src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=400&fit=crop" 
                alt="Our Mission" 
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-2xl font-bold text-catalina-blue mb-4">
              Our Mission
            </h3>
            <div className="text-gray-600 text-lg leading-relaxed">
              <ul className="space-y-4 mb-8">
                <li className="flex items-start text-left">
                  <FaCheckCircle className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <span className="font-bold">To design and deliver high-quality trolleys and handling</span>
                    <span className="text-gray-600"> systems that enhance productivity and reduce manual strain.</span>
                  </span>
                </li>
                <li className="flex items-start text-left">
                  <FaCheckCircle className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <span className="font-bold">To continuously innovate with durable materials and ergonomic</span>
                    <span className="text-gray-600"> designs tailored to industrial needs.</span>
                  </span>
                </li>
                <li className="flex items-start text-left">
                  <FaCheckCircle className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <span className="font-bold">To maintain a strong focus on customer satisfaction through</span>
                    <span className="text-gray-600"> reliability, timely delivery, and responsive support.</span>
                  </span>
                </li>
                <li className="flex items-start text-left">
                  <FaCheckCircle className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <span className="font-bold">To build long-term partnerships with clients by offering</span>
                    <span className="text-gray-600"> value-driven, cost-effective, and sustainable solutions.</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="w-32 h-32 mx-auto mb-6 overflow-hidden rounded-lg">
              <img 
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=400&fit=crop" 
                alt="Our Vision" 
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-2xl font-bold text-catalina-blue mb-4">
              Our Vision
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed text-left">
              To become India's most trusted partner in efficient and innovative
              material handling solutions, empowering industries with products
              that ensure safety, durability, and seamless mobility
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;